import React from "react";
import { useState } from "react";

const BoxScores = ({ data, league }) => {
  const quarterScores = {
    home: {
      actual: {
        q1: data.quarters.home_score_1q,
        q2: data.quarters.home_score_2q,
        q3: data.quarters.home_score_3q,
        q4: data.quarters.home_score_4q,
        ot: data.quarters.ot.map((it) => it.home_score_ot),
        total: data.game_info.home_score,
      },
      estimated: {
        q1: data.quarters.home_sq_score_1q,
        q2: data.quarters.home_sq_score_2q,
        q3: data.quarters.home_sq_score_3q,
        q4: data.quarters.home_sq_score_4q,
        ot: data.quarters.ot.map((it) => it.home_sq_score_ot),
        total: data.game_info.home_sq_score,
      },
      difference: {
        q1: data.quarters.home_sq_score_1q - data.quarters.home_score_1q,
        q2: data.quarters.home_sq_score_2q - data.quarters.home_score_2q,
        q3: data.quarters.home_sq_score_3q - data.quarters.home_score_3q,
        q4: data.quarters.home_sq_score_4q - data.quarters.home_score_4q,
        ot: data.quarters.ot.map((it) => it.home_sq_score_ot - it.home_score_ot),
        total:
          data.game_info.home_score &&
          data.game_info.home_sq_score &&
          data.game_info.home_sq_score - data.game_info.home_score,
      },
      fouls: {
        q1: data.quarters.home_fouls_1q,
        q2: data.quarters.home_fouls_2q,
        q3: data.quarters.home_fouls_3q,
        q4: data.quarters.home_fouls_4q,
        ot: data.quarters.ot.map((it) => it.home_fouls_ot),
        total:
          Number(data.quarters.home_fouls_1q) +
          Number(data.quarters.home_fouls_2q) +
          Number(data.quarters.home_fouls_3q) +
          Number(data.quarters.home_fouls_4q) +
          data.quarters.ot.reduce((acc, it) => acc + Number(it.home_fouls_ot), 0),
      },
    },
    away: {
      actual: {
        q1: data.quarters.away_score_1q,
        q2: data.quarters.away_score_2q,
        q3: data.quarters.away_score_3q,
        q4: data.quarters.away_score_4q,
        ot: data.quarters.ot.map((it) => it.away_score_ot),
        total: data.game_info.away_score,
      },
      estimated: {
        q1: data.quarters.away_sq_score_1q,
        q2: data.quarters.away_sq_score_2q,
        q3: data.quarters.away_sq_score_3q,
        q4: data.quarters.away_sq_score_4q,
        ot: data.quarters.ot.map((it) => it.away_sq_score_ot),
        total: data.game_info.away_sq_score,
      },
      difference: {
        q1: data.quarters.away_sq_score_1q - data.quarters.away_score_1q,
        q2: data.quarters.away_sq_score_2q - data.quarters.away_score_2q,
        q3: data.quarters.away_sq_score_3q - data.quarters.away_score_3q,
        q4: data.quarters.away_sq_score_4q - data.quarters.away_score_4q,
        ot: data.quarters.ot.map((it) => it.away_sq_score_ot - it.away_score_ot),
        total:
          data.game_info.away_score &&
          data.game_info.away_sq_score &&
          data.game_info.away_sq_score - data.game_info.away_score,
      },
      fouls: {
        q1: data.quarters.away_fouls_1q,
        q2: data.quarters.away_fouls_2q,
        q3: data.quarters.away_fouls_3q,
        q4: data.quarters.away_fouls_4q,
        ot: data.quarters.ot.map((it) => it.away_fouls_ot),
        total:
          Number(data.quarters.away_fouls_1q) +
          Number(data.quarters.away_fouls_2q) +
          Number(data.quarters.away_fouls_3q) +
          Number(data.quarters.away_fouls_4q) +
          data.quarters.ot.reduce((acc, it) => acc + Number(it.away_fouls_ot), 0),
      },
    },
  };
  const quarterPps = {
    home: {
      actual: {
        q1: data.pps.home_pps_1q,
        q2: data.pps.home_pps_2q,
        q3: data.pps.home_pps_3q,
        q4: data.pps.home_pps_4q,
        ot: data.pps.ot.map((it) => it.home_pps_ot),
        total: data.pps.home_pps,
      },
      estimated: {
        q1: data.pps.home_sq_pps_1q,
        q2: data.pps.home_sq_pps_2q,
        q3: data.pps.home_sq_pps_3q,
        q4: data.pps.home_sq_pps_4q,
        ot: data.pps.ot.map((it) => it.home_sq_pps_ot),
        total: data.pps.home_sq_pps,
      },
      difference: {
        q1: data.pps.home_sq_pps_1q - data.pps.home_pps_1q,
        q2: data.pps.home_sq_pps_2q - data.pps.home_pps_2q,
        q3: data.pps.home_sq_pps_3q - data.pps.home_pps_3q,
        q4: data.pps.home_sq_pps_4q - data.pps.home_pps_4q,
        ot: data.pps.ot.map((it) => it.home_sq_pps_ot - it.home_pps_ot),
        total: data.pps.home_sq_pps - data.pps.home_pps,
      },
      fouls: {
        q1: data.quarters.home_fouls_1q,
        q2: data.quarters.home_fouls_2q,
        q3: data.quarters.home_fouls_3q,
        q4: data.quarters.home_fouls_4q,
        ot: data.quarters.ot.map((it) => it.home_fouls_ot),
        total:
          Number(data.quarters.home_fouls_1q) +
          Number(data.quarters.home_fouls_2q) +
          Number(data.quarters.home_fouls_3q) +
          Number(data.quarters.home_fouls_4q) +
          data.quarters.ot.reduce((acc, it) => acc + Number(it.home_fouls_ot), 0),
      },
    },
    away: {
      actual: {
        q1: data.pps.away_pps_1q,
        q2: data.pps.away_pps_2q,
        q3: data.pps.away_pps_3q,
        q4: data.pps.away_pps_4q,
        ot: data.pps.ot.map((it) => it.away_pps_ot),
        total: data.pps.away_pps,
      },
      estimated: {
        q1: data.pps.away_sq_pps_1q,
        q2: data.pps.away_sq_pps_2q,
        q3: data.pps.away_sq_pps_3q,
        q4: data.pps.away_sq_pps_4q,
        ot: data.pps.ot.map((it) => it.away_sq_pps_ot),
        total: data.pps.away_sq_pps,
      },
      difference: {
        q1: data.pps.away_sq_pps_1q - data.pps.away_pps_1q,
        q2: data.pps.away_sq_pps_2q - data.pps.away_pps_2q,
        q3: data.pps.away_sq_pps_3q - data.pps.away_pps_3q,
        q4: data.pps.away_sq_pps_4q - data.pps.away_pps_4q,
        ot: data.pps.ot.map((it) => it.away_sq_pps_ot - it.away_pps_ot),
        total: data.pps.away_sq_pps - data.pps.away_pps,
      },
      fouls: {
        q1: data.quarters.away_fouls_1q,
        q2: data.quarters.away_fouls_2q,
        q3: data.quarters.away_fouls_3q,
        q4: data.quarters.away_fouls_4q,
        ot: data.quarters.ot.map((it) => it.away_fouls_ot),
        total:
          Number(data.quarters.away_fouls_1q) +
          Number(data.quarters.away_fouls_2q) +
          Number(data.quarters.away_fouls_3q) +
          Number(data.quarters.away_fouls_4q) +
          data.quarters.ot.reduce((acc, it) => acc + Number(it.away_fouls_ot), 0),
      },
    },
  };

  const NCCASCORES = {
    quarters: {
      home: {
        actual: {
          h1: data.quarters.home_score_1h,
          h2: data.quarters.home_score_2h,
          ot: data.quarters.ot.map((it) => it.home_score_ot),
          total: data.game_info.home_score,
        },
        estimated: {
          h1: data.quarters.home_sq_score_1h,
          h2: data.quarters.home_sq_score_2h,
          ot: data.quarters.ot.map((it) => it.home_sq_score_ot),
          total: data.game_info.home_sq_score,
        },
        difference: {
          h1: data.quarters.home_sq_score_1h - data.quarters.home_score_1h,
          h2: data.quarters.home_sq_score_2h - data.quarters.home_score_2h,
          ot: data.quarters.ot.map((it) => it.home_sq_score_ot - it.home_score_ot),
          total:
            data.game_info.home_score &&
            data.game_info.home_sq_score &&
            data.game_info.home_sq_score - data.game_info.home_score,
        },
        fouls: {
          h1: data.quarters.home_fouls_1h,
          h2: data.quarters.home_fouls_2h,
          ot: data.quarters.ot.map((it) => it.home_fouls_ot),
          total:
            Number(data.quarters.home_fouls_1h) +
            Number(data.quarters.home_fouls_2h) +
            data.quarters.ot.reduce((acc, it) => acc + Number(it.home_fouls_ot), 0),
        },
      },
      away: {
        actual: {
          h1: data.quarters.away_score_1h,
          h2: data.quarters.away_score_2h,
          ot: data.quarters.ot.map((it) => it.away_score_ot),
          total: data.game_info.away_score,
        },
        estimated: {
          h1: data.quarters.away_sq_score_1h,
          h2: data.quarters.away_sq_score_2h,
          ot: data.quarters.ot.map((it) => it.away_sq_score_ot),
          total: data.game_info.away_sq_score,
        },
        difference: {
          h1: data.quarters.away_sq_score_1h - data.quarters.away_score_1h,
          h2: data.quarters.away_sq_score_2h - data.quarters.away_score_2h,
          ot: data.quarters.ot.map((it) => it.away_sq_score_ot - it.away_score_ot),
          total:
            data.game_info.away_score &&
            data.game_info.away_sq_score &&
            data.game_info.away_sq_score - data.game_info.away_score,
        },
        fouls: {
          h1: data.quarters.away_fouls_1h,
          h2: data.quarters.away_fouls_2h,
          ot: data.quarters.ot.map((it) => it.away_fouls_ot),
          total:
            Number(data.quarters.away_fouls_1h) +
            Number(data.quarters.away_fouls_2h) +
            data.quarters.ot.reduce((acc, it) => acc + Number(it.away_fouls_ot), 0),
        },
      },
    },
    pps: {
      home: {
        actual: {
          h1: data.pps.home_pps_1h,
          h2: data.pps.home_pps_2h,
          ot: data.pps.ot.map((it) => it.home_pps_ot),
          total: data.pps.home_pps,
        },
        estimated: {
          h1: data.pps.home_sq_pps_1h,
          h2: data.pps.home_sq_pps_2h,
          ot: data.pps.ot.map((it) => it.home_sq_pps_ot),
          total: data.pps.home_sq_pps,
        },
        difference: {
          h1: data.pps.home_sq_pps_1h - data.pps.home_pps_1h,
          h2: data.pps.home_sq_pps_2h - data.pps.home_pps_2h,
          ot: data.pps.ot.map((it) => it.home_sq_pps_ot - it.home_pps_ot),
          total: data.pps.home_sq_pps && data.pps.home_pps && data.pps.home_sq_pps - data.pps.home_pps,
        },
        fouls: {
          h1: data.quarters.home_fouls_1h,
          h2: data.quarters.home_fouls_2h,
          ot: data.quarters.ot.map((it) => it.home_fouls_ot),
          total:
            Number(data.quarters.home_fouls_1h) +
            Number(data.quarters.home_fouls_2h) +
            data.quarters.ot.reduce((acc, it) => acc + Number(it.home_fouls_ot), 0),
        },
      },
      away: {
        actual: {
          h1: data.pps.away_pps_1h,
          h2: data.pps.away_pps_2h,
          ot: data.pps.ot.map((it) => it.away_pps_ot),
          total: data.pps.away_pps,
        },
        estimated: {
          h1: data.pps.away_sq_pps_1h,
          h2: data.pps.away_sq_pps_2h,
          ot: data.pps.ot.map((it) => it.away_sq_pps_ot),
          total: data.pps.away_sq_pps,
        },
        difference: {
          h1: data.pps.away_sq_pps_1h - data.pps.away_pps_1h,
          h2: data.pps.away_sq_pps_2h - data.pps.away_pps_2h,
          ot: data.pps.ot.map((it) => it.away_sq_pps_ot - it.away_pps_ot),
          total: data.pps.away_sq_pps && data.pps.away_pps && data.pps.away_sq_pps - data.pps.away_pps,
        },
        fouls: {
          h1: data.quarters.away_fouls_1h,
          h2: data.quarters.away_fouls_2h,
          ot: data.quarters.ot.map((it) => it.away_fouls_ot),
          total:
            Number(data.quarters.away_fouls_1h) +
            Number(data.quarters.away_fouls_2h) +
            data.quarters.ot.reduce((acc, it) => acc + Number(it.away_fouls_ot), 0),
        },
      },
    },
  };
  return (
    <div className="row">
      <div className="AppContentQuarterTableContainer col-12 col-md-6" data-score="shotquality" data-table="score">
        <QuarterTable
          quarterScores={quarterScores?.away}
          quarterPps={quarterPps.away}
          NCAAquarterScores={NCCASCORES.quarters.away}
          NCAAquarterPps={NCCASCORES.pps.away}
          league={league}
        />
      </div>
      <div className="AppContentQuarterTableContainer col-12 col-md-6" data-score="shotquality" data-table="score">
        <QuarterTable
          quarterScores={quarterScores.home}
          quarterPps={quarterPps.home}
          NCAAquarterScores={NCCASCORES.quarters.home}
          NCAAquarterPps={NCCASCORES.pps.home}
          league={league}
        />
      </div>
    </div>
  );
};

export const QuarterTable = ({ quarterScores, quarterPps, NCAAquarterScores, NCAAquarterPps, league }) => {
  const [showScore, setShowScore] = useState(false);
  const isCollege = league === "college_mens" || league === "ncaa" || league === "college_womens" || league === "ncaaw";
  const overtimeArrLength = isCollege ? NCAAquarterScores.actual.ot.length : quarterScores.actual.ot.length;
  return (
    <div className="overflow-auto">
      <div className="ScoreToggle">
        <button onClick={() => setShowScore(false)} data-active={!showScore}>
          SQPPS
        </button>
        <button onClick={() => setShowScore(true)} data-active={showScore}>
          Score
        </button>
      </div>
      <div className="AppContentQuarterTable" data-score="shotquality" data-table-team="away">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>1</th>
              <th>2</th>
              {isCollege || (
                <>
                  <th>3</th>
                  <th>4</th>
                </>
              )}
              {overtimeArrLength ? (
                overtimeArrLength === 1 ? (
                  <th>OT</th>
                ) : (
                  [...new Array(overtimeArrLength)].map((it, index) => <th key={index}>OT{index + 1}</th>)
                )
              ) : null}
              <th>T</th>
            </tr>
            <tr>
              <td colSpan={7} className="AppFooterTableBreak">
                <div></div>
              </td>
            </tr>
          </thead>

          {isCollege ? (
            showScore ? (
              <NCAAQuarterScoreTableBody
                scores={NCAAquarterScores}
                scoreType="SCORE"
                overtimeArrLength={overtimeArrLength}
              />
            ) : (
              <NCAAQuarterScoreTableBody
                scores={NCAAquarterPps}
                scoreType="PPS"
                overtimeArrLength={overtimeArrLength}
              />
            )
          ) : showScore ? (
            <QuarterScoreTableBody scores={quarterScores} scoreType="SCORE" overtimeArrLength={overtimeArrLength} />
          ) : (
            <QuarterScoreTableBody scores={quarterPps} scoreType="PPS" overtimeArrLength={overtimeArrLength} />
          )}
        </table>
      </div>
    </div>
  );
};

export const NCAAQuarterScoreTableBody = ({ scores, scoreType, overtimeArrLength }) => {
  const { actual, estimated, difference, fouls } = scores;
  return (
    <tbody>
      <tr>
        <td className="TitleDiv">
          <div className="TitleWrapper">
            <span className="IconWrapper">🏀SHOT</span>
            <span className="text-orange">QUALITY</span>
          </div>
          <div>
            <span>{scoreType}</span>
          </div>
        </td>
        <td>{estimated.h1}</td>
        <td>{estimated.h2}</td>
        {overtimeArrLength > 0 && estimated.ot.map((val, index) => <td key={index}>{val}</td>)}
        <td
        // style={{
        //   color: getScoreColor(estimated.total, actual.total, true, true),
        // }}
        >
          {estimated.total}
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>{scoreType}</span>
          </div>
        </td>
        <td
          style={{
            color: getScoreColor(estimated.h1, actual.h1, false, scoreType === "PPS"),
          }}
        >
          {actual.h1}
        </td>
        <td
          style={{
            color: getScoreColor(estimated.h2, actual.h2, false, scoreType === "PPS"),
          }}
        >
          {actual.h2}
        </td>
        {overtimeArrLength > 0 &&
          actual.ot.map((val, index) => (
            <td
              key={index}
              style={{
                color: getScoreColor(estimated.ot[index], val, false, scoreType === "PPS"),
              }}
            >
              {val}
            </td>
          ))}
        <td
          style={{
            color: getScoreColor(estimated.total, actual.total, false, scoreType === "PPS"),
          }}
        >
          {actual.total}
        </td>
      </tr>
      <tr>
        <td colSpan={7} className="AppFooterTableBreak">
          <div></div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>DIFF</span>
          </div>
        </td>

        <td>
          <ScoreDifferential difference={difference.h1} />
        </td>
        <td>
          <ScoreDifferential difference={difference.h2} />
        </td>
        {overtimeArrLength > 0 &&
          difference.ot.map((val, index) => (
            <td key={index}>
              <ScoreDifferential difference={val || 0} />
            </td>
          ))}
        <td>
          <ScoreDifferential difference={difference.total || 0} />
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Fouls</span>
          </div>
        </td>
        <td>
          {fouls.h1} {fouls.h1 > 8 ? "BONUS+" : fouls.h1 > 5 ? "BONUS" : ""}
        </td>
        <td>
          {fouls.h2} {fouls.h2 > 8 ? "BONUS+" : fouls.h2 > 5 ? "BONUS" : ""}
        </td>
        {overtimeArrLength > 0 &&
          fouls.ot.map((val, index) => {
            const value = val || 0;
            return (
              <td key={index}>
                {value}
                {value > 8 ? "BONUS+" : value > 5 ? "BONUS" : ""}
              </td>
            );
          })}
        <td>{fouls.total || 0}</td>
      </tr>
    </tbody>
  );
};

export const QuarterScoreTableBody = ({ scores, scoreType, overtimeArrLength }) => {
  const { actual, estimated, difference, fouls } = scores;

  return (
    <tbody>
      <tr>
        <td className="TitleDiv">
          <div className="TitleWrapper">
            <span className="IconWrapper">🏀SHOT</span>
            <span className="text-orange">QUALITY</span>
          </div>
          <div>
            <span>{scoreType}</span>
          </div>
        </td>
        <td>{estimated.q1}</td>
        <td>{estimated.q2}</td>
        <td>{estimated.q3}</td>
        <td>{estimated.q4}</td>
        {overtimeArrLength > 0 && estimated.ot.map((val, index) => <td key={index}>{val}</td>)}
        <td
        // style={{
        //   color: getScoreColor(estimated.total, actual.total, true, true),
        // }}
        >
          {estimated.total}
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>{scoreType}</span>
          </div>
        </td>
        <td
          style={{
            color: getScoreColor(estimated.q1, actual.q1, false, scoreType === "PPS"),
          }}
        >
          {actual.q1}
        </td>
        <td
          style={{
            color: getScoreColor(estimated.q2, actual.q2, false, scoreType === "PPS"),
          }}
        >
          {actual.q2}
        </td>
        <td
          style={{
            color: getScoreColor(estimated.q3, actual.q3, false, scoreType === "PPS"),
          }}
        >
          {actual.q3}
        </td>
        <td
          style={{
            color: getScoreColor(estimated.q4, actual.q4, false, scoreType === "PPS"),
          }}
        >
          {actual.q4}
        </td>
        {overtimeArrLength > 0 &&
          actual.ot.map((val, index) => (
            <td
              key={index}
              style={{
                color: getScoreColor(estimated.ot[index], val, false, scoreType === "PPS"),
              }}
            >
              {val}
            </td>
          ))}
        <td
          style={{
            color: getScoreColor(estimated.total, actual.total, false, scoreType === "PPS"),
          }}
        >
          {actual.total}
        </td>
      </tr>
      <tr>
        <td colSpan={7} className="AppFooterTableBreak">
          <div></div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>DIFF</span>
          </div>
        </td>

        <td>
          <ScoreDifferential difference={difference.q1} />
        </td>
        <td>
          <ScoreDifferential difference={difference.q2} />
        </td>
        <td>
          <ScoreDifferential difference={difference.q3} />
        </td>
        <td>
          <ScoreDifferential difference={difference.q4} />
        </td>
        {overtimeArrLength > 0 &&
          difference.ot.map((val, index) => (
            <td key={index}>
              <ScoreDifferential difference={val || 0} />
            </td>
          ))}
        <td>
          <ScoreDifferential difference={difference.total || 0} />
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Fouls</span>
          </div>
        </td>
        <td>{fouls.q1}</td>
        <td>{fouls.q2}</td>
        <td>{fouls.q3}</td>
        <td>{fouls.q4}</td>
        {overtimeArrLength > 0 && fouls.ot.map((val, index) => <td key={index}>{val || 0}</td>)}
        <td>{fouls.total || 0}</td>
      </tr>
    </tbody>
  );
};
export const ScoreDifferential = ({ difference }) => {
  return difference > 0 ? (
    <span className="UpGreenTriangle" style={{ filter: "hue-rotate(135deg)" }}>
      {difference?.toFixed(2)}🔺
    </span>
  ) : difference < 0 ? (
    <span className="DownRedTriangle">{difference?.toFixed(2)}🔻</span>
  ) : (
    <span>-</span>
  );
};
export const getScoreColor = (sq_score = null, score = null, total = null, isPPS = null) => {
  if (sq_score === undefined || score === undefined) return "white";
  const determineColor = (sq_score, score, isTotal) => {
    if (sq_score > score) return isTotal ? "#EF6C00" : "#7DC0EF";
    if (sq_score < score) return isTotal ? "#7DC0EF" : "#EF6C00";
    return "white";
  };
  if (sq_score === null || score === null) return "white";
  if (isPPS) return determineColor(sq_score, score, total);
  if (total) return sq_score - score > 2 ? "#EF6C00" : sq_score - score < -2 ? "#7DC0EF" : "white";
  return sq_score - score > 2 ? "#7DC0EF" : sq_score - score < -2 ? "#EF6C00" : "white";
};
export default BoxScores;
